<feature-toggle-provider [features]="configService.getSelfServiceConfig()">
    <mat-toolbar>
        <mat-toolbar-row class="first-navigation-row">
            <div class="container d-flex flex-row justify-content-between">
                <div class="d-flex align-items-center">
                    <button mat-icon-button class="d-lg-none me-3" (click)="menuButtonPressed()">
                        <mat-icon class="color-white">menu</mat-icon>
                    </button>
                    <a routerLink="" class="d-none d-md-block">
                        <img src="../../../../../assets/img/viessmann-white.svg" alt="Viessmann Logo" class="logo" />
                    </a>
                    <span class="ms-3 mb-0 d-none d-sm-block color-white app-name">{{ appName }}</span>
                </div>
                <div class="d-flex flex-row">
                    <div *featureToggle="'enablePersonalNotificationSettings'">
                        <vih-bell></vih-bell>
                    </div>
                    <div>
                        <vih-support-link></vih-support-link>
                    </div>
                    <div>
                        <vih-app-switcher> </vih-app-switcher>
                    </div>
                    <vih-login
                        [lang]="transLateService.currentLang ? transLateService.currentLang : 'en-GB'"
                        (logoutEvent)="auth.removeTokenFromLocalStorage()"
                    >
                    </vih-login>
                </div>
            </div>
        </mat-toolbar-row>
        <mat-toolbar-row class="second-navigation-row d-none d-lg-block" *ngIf="showSecondBar">
            <app-secondary-navigation></app-secondary-navigation>
        </mat-toolbar-row>
    </mat-toolbar>
</feature-toggle-provider>
